<template>

    <div class="row dashboard_stat">

        <balance/>

        <cash/>

        <card/>

        <less/>

        <total-today/>

        <total-month/>

    </div>

</template>

<script>
    export default {
        components: {
            balance: () => import('./Balance'),
            cash: () => import('./Cash'),
            card: () => import('./Card'),
            less: () => import('./Less'),
            totalToday: () => import('./TotalToday'),
            totalMonth: () => import('./TotalMonth'),
        },
    };
</script>
